import React from "react";

export const SeparatorComponent = ({className=''}) => {
  return (
    <hr className={`my-4 border-borderColor ${className}   sm:mx-auto dark:border-gray-700 flex justify-between lg:my-8`}/>  
  );
};
